export default "__VITE_ASSET__DUseBdG$__"